<template>
  <div class="index">
       <div class="logo"></div>
        <div class="big-light"></div>
    <div class="start-wrapper">
      <div class="start-test-btn" @click="startTest">我要测试</div>
      <div class="up-arrow"></div>
      <div class="test-text">测测你是马云要找的老师吗？</div>
    </div>
    <div class="main-wrapper">
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  methods: {
    startTest() {
      document.getElementById("myAudio").play();
      this.$router.push({
        path: "/UserInfo"
      });
    }
  }
};
</script>

<style lang="stylus">
.index {
  width: 100%;
  height: 100vh;
  background-image: url('../assets/images/bg1.png');
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  background-position: center
}

.figure {
  // position: relative;
  width: 100%;
  height 12rem;
  text-align: center;
}

.jack {
  // position: absolute;
  // bottom: -8rem;
  // width: 5.75rem;
  // height: 8rem;
  // left: 0.875rem;
  // background-image: url('../assets/images/jack.png');
  // background-size: cover;
  // background-repeat: no-repeat;

  // animation-name: figure,position2;
  // animation-duration: 3.6s, 1s;
  // animation-timing-function: linear, linear;
  // animation-delay: 1.3s, 0.3s;
  // animation-iteration-count: infinite, 1;
  // animation-direction: alternate, normal;
  // animation-fill-mode: forwards, forwards;
}
.small-light {
  position absolute;
  left -0.8rem;
  top -0.7rem;
  width 4.39rem;
  height 8.78rem;
  background-image: url('../assets/images/small-light.png');
  background-size: cover;
  background-repeat: no-repeat;
  animation-name: big-light;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-delay: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-fill-mode: forwards;
}

.start-wrapper {
  position: absolute;
  bottom: -4rem;
  left: 0;
  width: 7.5rem;
  height: 4.58rem;
  background-image: url('../assets/images/jack-hand.png');
  background-size: cover;
  background-repeat: no-repeat;
  animation-name: start-position;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-delay: 0.5s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  z-index: 10;
}

.start-test-btn {
  width: 4.7rem;
  height: 1.2rem;
  background: #ff6100;
  margin: 0 auto;
  text-align: center;
  font-size: 0.65rem;
  font-weight bold
  color: #f4eadf;
  border-radius: 0.125rem;
  line-height: 1.2rem;
  margin-top: 0.9rem;
  box-shadow: 6px 4px 10px 1px #fdaa78;
}
.up-arrow {
  width 0.24rem;
  height 0.21rem;
  background-image: url('../assets/images/up-arrow.png');
  background-size: cover;
  background-repeat: no-repeat;
  margin 0.3rem auto;
  }
.test-text{
  font-size 0.36rem;
  color #ff6100;
  text-align center;
  font-weight bold;
  margin-top -0.1rem
}
.logo {
  margin: 0 auto;
  width: 1.91rem;
  height: 0.54rem;
  background-image: url('../assets/images/logo.png');
  background-size: cover;
  background-repeat: no-repeat;
  margin-top 0.4rem
}
.big-light {
  position: absolute;
  top: 0;
  left: 0;
  width 5.39rem;
  height 6.86rem;
  background-image: url('../assets/images/big-light.png');
  background-size: cover;
  background-repeat: no-repeat;
  animation-name: big-light;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-fill-mode: forwards;
}
@keyframes big-light {
  from{
    filter: brightness(0.6);
  }to {
    filter: brightness(1.7);
  }
}
@keyframes figure {
  0% {
    transform: translate(0, 0);
    transform: scale(1);
  }

  50% {
    transform: translate(-0.1rem, -0.2rem);
    transform: scale(1.01);
  }

  100% {
    transform: translate(-0.1rem, -0.2rem);
    transform: scale(1);
  }
}

@keyframes position2 {
  0% {
    transform: scaleY(1);
    bottom: -8rem;
  }

  50% {
    transform: scaleY(1.05);
    bottom: 27%;
  }

  60% {
    transform: translateY(-0.1rem);
    bottom: 27%;
  }

  70% {
    transform: translateY(0rem);
    bottom: 27%;
  }

  80% {
    transform: translateY(0.1rem);
    bottom: 27%;
  }

  100% {
    transform: scaleY(1);
    bottom: 27%;
  }
}

@keyframes start-position {
  0% {
    transform: scaleY(1);
    bottom: -4rem;
  }

  50% {
    transform: scaleY(1.05);
    bottom: 0.5rem;
  }

  60% {
    transform: translateY(-0.1rem);
    bottom:  -0rem;
  }

  70% {
    transform: translateY(0rem);
    bottom:  -0rem;
  }

  80% {
    transform: translateY(0.1rem);
    bottom:  -0rem;
  }

  100% {
    transform: scaleY(1);
    bottom:  -0rem;
  }
}
</style>
